export default __webpack_public_path__ + "static/media/set-right.1beba329.svg";